import React, { createContext, useState, useContext, useEffect } from 'react';
import { loginAdmin, getCurrentAdmin, logoutAdmin } from '../services/AdminAuthService';

// Create admin context
const AdminContext = createContext();

// Admin Provider component
export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // Check auth status on mount
  useEffect(() => {
    checkAuthStatus();
  }, []);

  // Check if admin is authenticated
  const checkAuthStatus = async () => {
    setLoading(true);
    try {
      const adminData = getCurrentAdmin();
      if (adminData) {
        setAdmin(adminData);
        setIsAuthenticated(true);
      } else {
        setAdmin(null);
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.error("Admin auth check failed:", error);
      setAdmin(null);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  // Login function
  const login = async (email, password) => {
    try {
      const response = await loginAdmin(email, password);
      await checkAuthStatus();
      return response;
    } catch (error) {
      throw error;
    }
  };

  // Logout function
  const logout = () => {
    try {
      logoutAdmin();
      setAdmin(null);
      setIsAuthenticated(false);
      return { success: true };
    } catch (error) {
      throw error;
    }
  };

  // Context value
  const value = {
    admin,
    isAuthenticated,
    loading,
    login,
    logout,
    checkAuthStatus
  };

  return (
    <AdminContext.Provider value={value}>
      {children}
    </AdminContext.Provider>
  );
};

// Create and export the useAdmin hook
export const useAdmin = () => {
  return useContext(AdminContext);
};

// Default export for anyone that needs the context directly
export default AdminContext;
